import { OnInit } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent(themeSettingService) {
        this.themeSettingService = themeSettingService;
    }
    LoadingComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    return LoadingComponent;
}());
export { LoadingComponent };
